import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Properties() {
      constructor() {
        Default_instance = null;
        super(EmptySerializersModule(), null);
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var PropertiesClass;
function Properties() {
  if (PropertiesClass === VOID) {
    class $ {
      constructor(serializersModule, ctorMarker) {
        Default_getInstance();
        this.serializersModule_1 = serializersModule;
      }
    }
    initMetadataForClass($, 'Properties');
    PropertiesClass = $;
  }
  return PropertiesClass;
}
function Properties_0(module_0) {
  return new (PropertiesImpl())(module_0);
}
var PropertiesImplClass;
function PropertiesImpl() {
  if (PropertiesImplClass === VOID) {
    class $ extends Properties() {
      constructor(serializersModule) {
        super(serializersModule, null);
      }
    }
    initMetadataForClass($, 'PropertiesImpl');
    PropertiesImplClass = $;
  }
  return PropertiesImplClass;
}
//region block: exports
export {
  Properties_0 as Properties3rdc3388jbgie,
};
//endregion

//# sourceMappingURL=Properties.mjs.map
